export default __webpack_public_path__ + "static/media/awards-error.b2f5d310.jpg";